module.exports = __webpack_public_path__ + "img/pro-zdslider2.dcdf27da.png";